export const SimilarSearchIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95768 0C6.35224 0 6.70254 0.252478 6.82731 0.626791L7.71362 3.28573L10.3726 4.17204C10.7469 4.29681 10.9993 4.64711 10.9993 5.04167C10.9993 5.43623 10.7469 5.78652 10.3726 5.91129L7.71362 6.79761L6.82731 9.45654C6.70254 9.83086 6.35224 10.0833 5.95768 10.0833C5.56312 10.0833 5.21283 9.83086 5.08806 9.45654L4.20174 6.79761L1.54281 5.91129C1.16849 5.78652 0.916016 5.43623 0.916016 5.04167C0.916016 4.64711 1.16849 4.29681 1.54281 4.17204L4.20174 3.28573L5.08806 0.626791C5.21283 0.252478 5.56312 0 5.95768 0ZM5.95768 3.81542L5.79606 4.30029C5.70482 4.57401 5.49003 4.7888 5.21631 4.88004L4.73144 5.04167L5.21631 5.20329C5.49003 5.29453 5.70482 5.50932 5.79606 5.78304L5.95768 6.26791L6.11931 5.78304C6.21055 5.50932 6.42534 5.29453 6.69906 5.20329L7.18393 5.04167L6.69906 4.88004C6.42534 4.7888 6.21055 4.57401 6.11931 4.30029L5.95768 3.81542Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0642 14.9352C7.42218 15.2931 7.42218 15.8735 7.0642 16.2315L3.39753 19.8982C3.03955 20.2562 2.45915 20.2562 2.10117 19.8982C1.74319 19.5402 1.74319 18.9598 2.10117 18.6018L5.76783 14.9352C6.12581 14.5772 6.70622 14.5772 7.0642 14.9352Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9343 3.62183C12.035 3.12569 12.5189 2.80513 13.015 2.90584C16.5719 3.62785 19.2493 6.77106 19.2493 10.5417C19.2493 14.8449 15.7609 18.3333 11.4577 18.3333C8.0637 18.3333 5.1788 16.1638 4.10961 13.1388C3.9409 12.6615 4.19108 12.1378 4.6684 11.9691C5.14572 11.8004 5.66944 12.0505 5.83815 12.5279C6.65654 14.8433 8.86481 16.5 11.4577 16.5C14.7484 16.5 17.416 13.8324 17.416 10.5417C17.416 7.66014 15.3696 5.25452 12.6503 4.70253C12.1542 4.60182 11.8336 4.11798 11.9343 3.62183Z"
        fill="white"
      />
    </svg>
  );
};
